import { HomeComponent } from './home.component';

export const HOME_COMPONENTS: any[] = [
  HomeComponent,
];



// WEBPACK FOOTER //
// ./src/app/components/home/index.ts